import Bowser from 'bowser'

export const isSafari = (): boolean => {
  try {
    const browser = Bowser.getParser(window.navigator.userAgent).getBrowserName().toLowerCase()

    return browser === 'safari'
  } catch (e) {
    return false
  }
}

export const isFirefox = (): boolean => {
  try {
    const browser = Bowser.getParser(window.navigator.userAgent).getBrowserName().toLowerCase()

    return browser === 'firefox'
  } catch (e) {
    return false
  }
}

export const isChrome = (): boolean => {
  try {
    const browser = Bowser.getParser(window.navigator.userAgent).getBrowserName().toLowerCase()

    return browser === 'chrome'
  } catch (e) {
    return false
  }
}
